import { type Components, type Theme } from '@mui/material';

export const MuiTab: Components<Theme>['MuiTab'] = {
  styleOverrides: {
    root: ({ theme: { spacing, typography, palette } }) => ({
      ...typography['natter-text-sm'],
      color: palette.grey[700],
      minHeight: 'auto',
      minWidth: 'auto',
      padding: spacing(2, 1.25),
      textTransform: 'none',

      fontWeight: 500,
      '&.Mui-selected': {
        fontWeight: 600,
      },
    }),
  },
};
